export default "__VITE_ASSET__8R8TSd6L__"